/**
 * @fileoverview Agent definition for chapter-drafter-v2-neutral.
 *
 * A reduced variant of chapter-drafter-v2 focused on continuity, pacing,
 * and beats. Outputs deliberately neutral prose intended to be transformed
 * by a downstream stylization pass (e.g., style-aligner-v2).
 *
 * @category narrative.prose.drafting
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'chapter-drafter-v2-neutral',
  kind: 'primitive',
  name: 'Chapter Drafter (Neutral)',
  description: 'Drafts a chapter focused on continuity, pacing, and beats. Outputs deliberately neutral prose with no style/voice attempt; intended to be paired with a downstream stylization pass.',
  category: 'writing',
  defaultPrompt: prompt,
  systemPrompt: `You are a narrative architect drafting fiction prose. You prioritize continuity, pacing, and beats over style. You write in plain, workmanlike prose; a downstream stylization pass will apply voice and tone.`,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-05',
    lastUpdated: '2026-05',
    taxonomyPath: 'narrative.prose.drafting',
    usedBy: [
      'use-content-creation-v2.ts',
      'use-ai-control-panel.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'chapter-drafter-v2',
      'style-aligner-v2',
    ],
  },
};
